import { Dispatch } from 'redux';
import streamStompMiddleware from './streamStompMiddleware';
import streamApiMiddleware from './streamApiMiddleware';

// Chosen once per store rather than per action: the inner middleware closes over
// the store and must not be rebuilt on every dispatch.
const streamServiceMiddleware = (store: { getState; dispatch: Dispatch }) =>
  process.env.REACT_APP_STREAM_SERVICE_STOMP_URL
    ? streamStompMiddleware(store)
    : streamApiMiddleware(store);

export default streamServiceMiddleware;
